const emailProviderSelector = (state) => state.emailProvider
export const emailProviderLoadingSelector = (state) => emailProviderSelector(state).loading
export const emailProviderValueSelector = (state) => emailProviderSelector(state).provider
export const emailProviderSettledSelector = (state) => emailProviderSelector(state).fulfilled || emailProviderSelector(state).rejected
